import { render } from "./LogoutConfirmModal.vue?vue&type=template&id=31dcff27"
import script from "./LogoutConfirmModal.vue?vue&type=script&lang=js"
export * from "./LogoutConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"LogoutConfirmModal.vue"]])

export default __exports__